import { svg } from 'lit';

export const ellipsisIcon = svg`<svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 2C4 3.1045 3.1045 4 2 4C0.8955 4 0 3.1045 0 2C0 0.8955 0.8955 0 2 0C3.1045 0 4 0.8955 4 2ZM10 2C10 3.1045 9.1045 4 8 4C6.8955 4 6 3.1045 6 2C6 0.8955 6.8955 0 8 0C9.1045 0 10 0.8955 10 2ZM14 4C15.1045 4 16 3.1045 16 2C16 0.8955 15.1045 0 14 0C12.8955 0 12 0.8955 12 2C12 3.1045 12.8955 4 14 4Z" fill="#777777"/>
</svg>`;
